import { useState } from 'react';
import { useAuthStore } from '../store/authStore';
import { authService } from '../services/authService';
import { LoginCredentials, User } from '../types/auth.types';
import { handleApiError } from '@/lib/utils/errorHandler';

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { login: setAuthState } = useAuthStore();

  const login = async (credentials: LoginCredentials): Promise<User | null> => {
    setLoading(true);
    setError(null);

    try {
      const user = await authService.login(credentials);
      // Session cookie is set automatically by backend, no token needed
      setAuthState(user, ''); // Pass empty string for token (session-based auth)
      return user;
    } catch (err) {
      const apiError = handleApiError(err);
      setError(apiError.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { login, loading, error };
};
